/*! tailwindcss v4.3.3 | MIT License | https://tailwindcss.com */
@layer properties;
.button {
  padding-inline: calc(var(--spacing, 0.25rem) * 28);
  padding-block: calc(var(--spacing, 0.25rem) * 6);
  background-color: var(--color-primary-050);
  color: var(--color-primary-500);
  border-style: var(--tw-border-style);
  border-width: 1px;
  border-color: var(--color-primary-500);
  --tw-border-style: dashed;
  border-style: dashed;
  border-radius: var(--radius-lg, 0.5rem);
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: calc(var(--spacing, 0.25rem) * 2);
  color: var(--color-emphasis-medium, #525252);
  background-size: cover;
  position: relative;
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  text-align: center;
}
.button.hasError {
  background-color: var(--color-danger-light, #fef2f2);
  border-style: var(--tw-border-style);
  border-width: 1px;
  border-color: var(--color-danger-dark, #b91c1c);
}
.button.disabled {
  opacity: 30%;
}
.button.dragging {
  background-color: var(--color-primary-100);
  border-style: var(--tw-border-style);
  border-width: 2px;
}
.container {
  display: flex;
  gap: calc(var(--spacing, 0.25rem) * 4);
  @media (width >= 48rem) {
    display: block;
  }
}
.button .title {
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  margin-top: calc(var(--spacing, 0.25rem) * 2);
}
.iconContainer {
  background-color: color-mix(in srgb, #000 20%, transparent);
  @supports (color: color-mix(in lab, red, red)) {
    background-color: color-mix(in oklab, var(--color-black, #000) 20%, transparent);
  }
  padding-top: calc(var(--spacing, 0.25rem) * 5);
  width: 100%;
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  color: var(--color-white, #fff);
  top: 0px;
  left: 0px;
  position: absolute;
  height: 100%;
  border-radius: var(--radius-lg, 0.5rem);
  text-align: center;
}
.smallButton {
  padding: calc(var(--spacing, 0.25rem) * 4);
  height: calc(var(--spacing, 0.25rem) * 16);
  width: calc(var(--spacing, 0.25rem) * 16);
  gap: 0px;
}
.fileCardDesktop {
  width: 100%;
  height: calc(var(--spacing, 0.25rem) * 16);
  margin-top: calc(var(--spacing, 0.25rem) * 4);
}
.fileCardDesktop .container {
  display: grid;
  grid-template-columns: 64px 240px auto;
  gap: calc(var(--spacing, 0.25rem) * 4);
  height: 100%;
}
.fileCardDesktop .content {
  display: flex;
  flex-direction: column;
  gap: var(--spacing, 0.25rem);
  justify-content: center;
}
.fileCardDesktop img {
  border-top-left-radius: var(--radius-lg, 0.5rem);
  border-bottom-left-radius: var(--radius-lg, 0.5rem);
  width: calc(var(--spacing, 0.25rem) * 16);
  height: calc(var(--spacing, 0.25rem) * 16);
  object-fit: cover;
}
.fileCardDesktop .title {
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  color: var(--color-emphasis-high, #000);
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.fileCardDesktop .description {
  font-size: var(--text-xs, 0.75rem);
  line-height: var(--tw-leading, var(--text-xs--line-height, calc(1 / 0.75)));
  color: var(--color-emphasis-medium, #525252);
}
.fileCardDesktop .buttonContainer {
  display: flex;
  justify-content: flex-end;
  padding-right: calc(var(--spacing, 0.25rem) * 4);
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  align-items: center;
}
.buttonContainer button {
  &:hover {
    @media (hover: hover) {
      background-color: var(--color-gray-100, #f5f5f5);
    }
  }
  width: calc(var(--spacing, 0.25rem) * 8);
  height: calc(var(--spacing, 0.25rem) * 8);
  border-radius: var(--radius-sm, 0.25rem);
}
.fileCardMobile {
  width: calc(var(--spacing, 0.25rem) * 16);
  height: calc(var(--spacing, 0.25rem) * 16);
  position: relative;
  border-radius: var(--radius-lg, 0.5rem);
}
.button input[type="file"] {
  cursor: pointer;
  z-index: 10;
}
.button input[type="file"]:disabled {
  cursor: not-allowed;
  opacity: 0%;
}
.uploadTitle {
  color: var(--color-emphasis-medium, #525252);
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  --tw-font-weight: var(--font-weight-semibold, 600);
  font-weight: var(--font-weight-semibold, 600);
}
.uploadDescription {
  color: var(--color-emphasis-medium, #525252);
  font-size: var(--text-base, 1rem);
  line-height: var(--tw-leading, var(--text-base--line-height, calc(1.5 / 1)));
  --tw-font-weight: var(--font-weight-normal, 400);
  font-weight: var(--font-weight-normal, 400);
}
.uploadDescription.smallDescription {
  font-size: var(--text-sm, 0.875rem);
  line-height: var(--tw-leading, var(--text-sm--line-height, calc(1.25 / 0.875)));
  margin-bottom: calc(var(--spacing, 0.25rem) * 4);
}
@property --tw-border-style {
  syntax: "*";
  inherits: false;
  initial-value: solid;
}
@property --tw-font-weight {
  syntax: "*";
  inherits: false;
}
@layer properties {
  @supports ((-webkit-hyphens: none) and (not (margin-trim: inline))) or ((-moz-orient: inline) and (not (color:rgb(from red r g b)))) {
    *, ::before, ::after, ::backdrop {
      --tw-border-style: solid;
      --tw-font-weight: initial;
    }
  }
}
